import React from "react";
import { Button, ButtonVariant, Tooltip } from "@patternfly/react-core";
import { FiCircle, FiCheckCircle } from "react-icons/fi";
import { shareResolveOptimistic } from "../../../utils/share";

export const ShareCell = ({ row, props, setSheets, branch, context }) => {
  const isSuperuser = context.state.isAuthUser && context.state.userProfile?.is_superuser;
  const activeSolutions = (row.raw.solutions || []).filter(
    sol => sol.published
  );
  const canShare = isSuperuser && activeSolutions.length > 0;

  // 🔥 Stan globalnego udostępnienia
  const isShared = row.raw.solution_published || false;
  
  
  const handleShare = (event, value) => {
    event.stopPropagation();
    if (!isSuperuser) return;

    shareResolveOptimistic(
      props.state.api_url,
      props.state.organization_symbol,
      branch,
      row.raw.sheet_id,
      value, // 1 = udostępnij, 0 = cofnij
      setSheets
    );
  };

  return (
    <>
      {((row.raw.html_css_url || row.raw.solution_url || row.raw.solution_url) || (row.raw.solutions && row.raw.solutions.length > 0)) && (
        <Tooltip content={isShared ? `Udostępnienie rozwiązań wygaśnie o ${row.raw?.expiration_solution_sharing}` : "Udostępnij rozwiązania"}>  
          <Button
            variant={ButtonVariant.plain}
            size="sm"
            onClick={(e) => handleShare(e, isShared ? 0 : 1)}
            // isDisabled={!isSuperuser} // tylko superuser może udostępniać
            isDisabled={!canShare} // tylko jeśli superuser i są aktywne rozwiązania
          >
            {isShared ? <FiCheckCircle /> : <FiCircle />}
          </Button>
        </Tooltip>
      )}
    </>
  );
};